import React from 'react';
import { Form, Button, Row, Col } from 'react-bootstrap';

function ReplaceSettings({ replacements, setReplacements }) {
  const handleAdd = () => {
    setReplacements([...replacements, { find: '', replace: '' }]);
  };

  const handleRemove = (index) => {
    const updated = [...replacements];
    updated.splice(index, 1);
    setReplacements(updated);
  };

  const handleChange = (index, field, value) => {
    const updated = [...replacements];
    updated[index][field] = value;
    setReplacements(updated);
  };

  return (
    <div>
      {replacements.map((pair, index) => (
        <Row key={index} className="mb-2 align-items-center">
          <Col md={5}>
            <Form.Control
              type="text"
              placeholder="کلمه اصلی"
              value={pair.find}
              onChange={(e) => handleChange(index, 'find', e.target.value)}
            />
          </Col>
          <Col md={5}>
            <Form.Control
              type="text"
              placeholder="کلمه جایگزین"
              value={pair.replace}
              onChange={(e) => handleChange(index, 'replace', e.target.value)}
            />
          </Col>
          <Col md={2}>
            <Button variant="danger" onClick={() => handleRemove(index)}>
              حذف
            </Button>
          </Col>
        </Row>
      ))}
      <Button variant="success" onClick={handleAdd}>
        + افزودن کلمه جدید
      </Button>
    </div>
  );
}

export default ReplaceSettings;
